<template>
  <div>
    <v-row>
      <v-col>
        <h2 class="mb-3 mt-3 ml-3">{{ $t('account.privacySettings')}}</h2>

        <v-card elevation=0>
          <v-card-text>
            <DeleteAccountDialog :open-on-mount="openDeleteDialog">
              <v-btn color="red-darken-3" variant="outlined" elevation=0>
                {{$t('account.deleteMyAccount')}}
              </v-btn>
            </DeleteAccountDialog>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DeleteAccountDialog from '../dialogs/DeleteAccountDialog.vue'

export default {
  name: "PrivacySettings",
  components: {
    DeleteAccountDialog
  },
  props: {
    openDeleteDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
    }
  },
  methods: {

  },
  computed: {

  }
}
</script>

<style>

</style>
